import {Trans, useTranslation, withTranslation} from "react-i18next";

const { useEffect } = React;

import React from "react";

import { Form, Field, withFormik } from 'formik';
import * as Yup from 'yup'
import { TextField } from 'formik-material-ui';

import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import {Link as RouterLink} from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  margin: {
    marginBottom: theme.spacing(1)
  },
}));

const TextFieldWithMargin = (props) => {
  const classes = useStyles();
  return <TextField className={classes.margin} {...props} />
}


const ShippingForm = ({addOrEdit, isValid}) => {
  const {t} = useTranslation();

  return (
    <Form>
      <Field component={TextFieldWithMargin} name='name' label={t("Name")} fullWidth/>
      <Field component={TextFieldWithMargin} name='address' label={t("Address")} fullWidth />
      <Field component={TextFieldWithMargin} name='postalCode' label={t("Postal code")} fullWidth />
      <Field component={TextFieldWithMargin} name='city' label={t("City")}  fullWidth />

      <Field component={TextFieldWithMargin} name='mobile' label={t("Mobile number")} fullWidth />
      <Field component={TextFieldWithMargin} name='email' label={t("Email address")} fullWidth />

      <Box mt={2} mb={2}>
        <Button type='submit' variant="contained" color="primary" fullWidth disabled={!isValid}>
          <Trans>Proceed to payment</Trans>
        </Button>
      </Box>
    </Form>
  )
}

const validationSchema = ({t}) => {
  return Yup.object().shape({
    name: Yup.string()
        .matches(/^[^@]*$/, t("Minimum two parts, only characters allowed"))
        .test('is-two-parts', t('Minimum two parts, only characters allowed'), (value) => {
            return value && value.trim().split(/\s+/).length >= 2;
        })
        .required(t('Name is required')),
    address: Yup.string()
        // Make sure we have a space in the address:
        //.matches(/\S\s+\S/, t('Minimum two parts, only characters and numbers allowed'))
        .required(t('Address is required')),
    postalCode: Yup.string()
      .required(t('Postal code is required')),
    city: Yup.string()
      .required(t('City is required')),
    mobile: Yup.string()
      .required(t('Mobile phone is required')),
    email: Yup.string()
      .email(t('Invalid email format'))
      .required(t('Email address is required')),
  })
}

const getUserAddress = (user, what) => {
    if (user && user.address) {
        return user.address[what];
    }
    return null;
}

const mapPropsToValues = ({customerInfo, user}) => {
  return {
    name: customerInfo && customerInfo.name || user && user.name || '',
    address: customerInfo && customerInfo.address || getUserAddress(user, 'address') || '',
    postalCode: customerInfo && customerInfo.postalCode || getUserAddress(user, 'postalCode') || '',
    city: customerInfo && customerInfo.city || getUserAddress(user, 'city') || '',
    mobile: customerInfo && customerInfo.mobile || user && user.mobile || '',
    email: customerInfo && customerInfo.email || user && user.email || '',
  }
}

export default withTranslation()(withFormik({
  isInitialValid: props => validationSchema(props).isValidSync(mapPropsToValues(props)),
  mapPropsToValues,
  validationSchema,
  handleSubmit(values, {props})  {

    props.onSubmit(values)

  },
})(ShippingForm));
